import axios from '@/utils/request.js'

// 获取首页数据
export function getData(params) {
  return axios.get('/home/index', {
    params
  })
}